// extracted by mini-css-extract-plugin
module.exports = {"topbar":"Topbar_topbar__16Eir","placeholder":"Topbar_placeholder__1479r","name":"Topbar_name__xRM4u","link":"Topbar_link__3jGUA"};